import axios from "../config/axios.v2";
import { DASHBOARD_COUNTS_URL } from "./dashboard.url.service";

const unwrap = (res) => res.data?.data ?? res.data;

const handleError = (err) => {
  console.log("dashboardService err::", err);
  throw err;
};

const DashboardService = {
  getCounts: () => axios.get(DASHBOARD_COUNTS_URL).then(unwrap).catch(handleError)
};

export default DashboardService;
